var PaginationItemType;
(function(PaginationItemType2) {
  PaginationItemType2["ITEM"] = "ITEM";
  PaginationItemType2["JUMP_FORWARD"] = "JUMP_FORWARD";
  PaginationItemType2["JUMP_BACKWARDS"] = "JUMP_BACKWARDS";
})(PaginationItemType || (PaginationItemType = {}));

export { PaginationItemType };
